// type.ts
export interface KeyType {
  id: string;
  name: string;
  description: string;
}

export interface Role {
  id: string;
  name: string;
  description: string;
}

export interface Subgraph {
  id: string;
  name: string;
  type: 'subgraph';
}

export interface Variant {
  id: string;
  name: string;
  type: 'variant';
  subgraphs: Subgraph[];
}

export interface Graph {
  id: string;
  name: string;
  type: 'graph';
  variants: Variant[];
}

export const keyTypes: KeyType[] = [
  {
    id: 'organization',
    name: 'Organization API Key',
    description: 'Admin access to all organization resources.',
  },
  {
    id: 'graph',
    name: 'Graph API Key',
    description: 'Access to manage and query specific graphs.',
  },
  {
    id: 'variant',
    name: 'Variant API Key',
    description: 'Access to manage and query specific variants of a graph',
  },
  {
    id: 'subgraph',
    name: 'Subgraph API Key',
    description: 'Access to manage and query specific subgraphs of a graph.',
  },
];

export const roles: Role[] = [
  {
    id: 'admin',
    name: 'Graph Admin',
    description: 'Full administrative access to entity.',
  },
  {
    id: 'contributor',
    name: 'Contributor',
    description: 'Can create and modify entities',
  },
  {
    id: 'observer',
    name: 'Observer',
    description: 'Read-only access to entities',
  },
  {
    id: 'consumer',
    name: 'Consumer',
    description: 'Can use entities but not modify them',
  },
];
